import React, { useLayoutEffect } from "react";
import { Button, Divider, Stack, Typography } from "@mui/material";
import { blueGrey, grey } from "@mui/material/colors";

import { LottieIcon, PageContainer } from "src/shared/ui";
import { LottieIconNames } from "src/shared/config";
import { VacancyItem } from "src/widgets/VacancionItem";
import { useAppDispatch, useAppSelector } from "src/shared/hooks";
import { careersModel } from "src/entities/careers";

export const CareerPage: React.FC = () => {
  const dispatch = useAppDispatch();

  const careers = useAppSelector(careersModel.selectors.selectCareers);

  useLayoutEffect(() => {
    dispatch(careersModel.thunks.getCareers());
  }, []);

  return (
    <PageContainer
      hidden
      mainComponent={
        <>
          <Stack
            width={1}
            height={1}
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
            zIndex={99}
            sx={{
              alignItems: {
                xs: "center",
                sm: "flex-start",
              },
            }}
          >
            <Typography
              variant="h1"
              fontWeight="bold"
              color={blueGrey[700]}
              textTransform="uppercase"
              textAlign="center"
            >
              Career
            </Typography>
            <Typography
              variant="h5"
              color={grey[700]}
              textAlign="center"
              textTransform="uppercase"
            >
              Start your career with us
            </Typography>

            <Button variant="contained" size="large">
              Contact us
            </Button>
          </Stack>

          <Stack
            sx={{
              display: {
                xs: "none",
                sm: "flex",
              },
            }}
          >
            <LottieIcon
              icon={LottieIconNames.CAREER}
              autoPlay
              loop
              style={{
                position: "absolute",
                height: "calc(100% - 180px)",
                transform: "translateX(150px)",
                top: 0,
                right: 0,
              }}
            />
          </Stack>
        </>
      }
    >
      <Stack maxWidth="lg">
        <Typography
          variant="subtitle1"
          whiteSpace="pre-wrap"
          color={blueGrey[800]}
        >
          Come and join MathrixAI’s fast-growing IT team and learn how it is to
          have that dream job, at a very fresh and innovative company. {"\n"}
          {"\n"}Our employees are our most valued assets, so if you have what it
          takes and want to work in a relaxed and friendly environment, where
          colleagues hang out together and enjoy company-provided meals and
          drinks while discussing existing projects, then complete the
          application form below and let us know about your skills and desires
          to Join Digitain today. Also make sure to check-in regularly for the
          latest positions, as we are always expanding and are on the look-out
          for new talented IT professionals.
        </Typography>
      </Stack>

      <Typography
        variant="h4"
        color={blueGrey[600]}
        letterSpacing={4}
        textTransform="uppercase"
      >
        Vacancies
      </Typography>

      <Stack width={1} direction="column" gap={2} maxWidth="lg">
        {careers.map((career) => (
          <React.Fragment key={career.id}>
            <VacancyItem career={career} />
            <Divider component="div" />
          </React.Fragment>
        ))}
      </Stack>
    </PageContainer>
  );
};
